import Alpine from "alpinejs";

document.addEventListener("alpine:init", () => {
  Alpine.data(
    "objectCreateForm",
    (uploadUrl: string, uploadFailedMsg: string, noFileMsg: string) => ({
      type: "document",
      uploading: false,
      progress: 0,
      filename: "",
      storageKey: "",
      sizeBytes: 0,
      error: "",
      labels: { uploadUrl, uploadFailed: uploadFailedMsg, noFile: noFileMsg },

      async handleUpload(e: Event) {
        const target = e.target as HTMLInputElement;
        const file = target.files?.[0];
        if (!file) return;
        if (file.type !== "application/pdf") {
          this.error = "Invalid file type. Please upload a PDF.";
          return;
        }

        this.uploading = true;
        this.progress = 0;
        this.error = "";

        try {
          // 1. Get Presigned URL
          const resp = await fetch(this.labels.uploadUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token":
                document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "",
            },
            body: JSON.stringify({ filename: file.name, content_type: file.type }),
          });

          if (!resp.ok) throw new Error(this.labels.uploadFailed);
          const { url, storage_key } = await resp.json();

          // 2. Upload to R2
          const xhr = new XMLHttpRequest();
          xhr.open("PUT", url, true);
          xhr.setRequestHeader("Content-Type", file.type);

          xhr.upload.onprogress = (evt: ProgressEvent) => {
            if (evt.lengthComputable) {
              this.progress = Math.round((evt.loaded / evt.total) * 100);
            }
          };

          xhr.onload = () => {
            if (xhr.status === 200) {
              this.filename = file.name;
              this.storageKey = storage_key;
              this.sizeBytes = file.size;
              this.uploading = false;
            } else {
              this.error = this.labels.uploadFailed;
              this.uploading = false;
            }
          };

          xhr.onerror = () => {
            this.error = this.labels.uploadFailed;
            this.uploading = false;
          };

          xhr.send(file);
        } catch (err: any) {
          this.error = err.message;
          this.uploading = false;
        }
      },
    }),
  );
});
